import getVisitorId from 'mex_components/app/scripts/storage/getVisitorId';
import getClientId from 'mex_components/app/scripts/storage/getClientId';
import getMeta from 'mex_components/app/scripts/storage/getMeta';


export default function(data) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'user_addToCart',
    currency: getMeta('product:price:currency'),
    value: data.attributes.original_price_cents /100,
    contents: [{
      id: data.attributes.external_id,
      quantity: 1,
      parentID: getMeta('product:retailer_item_id'),
      slug: getMeta('og:url'),
      businessUnit: getMeta('product:brand')
    }],
    visitor_id: getVisitorId(),
    client_id: getClientId()
  });
}
